module.exports = __webpack_public_path__ + "img/x-small.ca111c64.svg";